import {InjectionToken} from '@angular/core';
import type {AppConfig, AppConfigFactory} from './app-config';
export type {AppConfig, AppConfigFactory};
export const APP_CONFIG = new InjectionToken<AppConfig>('app.config');
export const HOST = new InjectionToken<string>('host');